import * as R from "ramda";
import React, { Fragment, Component } from "react";
import {
  Button,
  Confirm,
  showNotification,
  refreshView,
  withDataProvider,
} from "react-admin";
import { dataProvider } from "../../App";
import {
  LINK_TO_CONSUMER,
  UNLINK_FROM_CONSUMER,
} from "../../redux/patients/actions";

class LinkPatientToConsumerButton_ extends Component {
  state = {
    isOpen: false,
    showWidget: false,
  };

  handleClick = () => {
    this.setState({ isOpen: true, showWidget: true });
  };

  handleDialogClose = () => {
    this.setState({ isOpen: false });
  };

  handleConfirm = () => {
    const { record } = this.props;
    this.setState({ isOpen: false, showWidget: false });
    dataProvider(LINK_TO_CONSUMER, "patients", { id: record.id })
      .then(() => {
        this.props.dispatch(
          showNotification("Patient linked to Consumer Backed")
        );
        this.props.dispatch(refreshView());
      })
      .catch((err) => {
        const message = R.pathOr(null, ["body", "message"], err);
        const status = R.pathOr(null, ["status"], err);
        if (status === 404) {
          this.props.dispatch(
            showNotification("User not found at Consumer", "warning")
          );
          return;
        }
        if (message) {
          this.props.dispatch(showNotification(message, "warning"));
          return;
        } else {
          this.props.dispatch(showNotification("Error: unknown", "warning"));
        }
      });
  };

  getConfirm = () => {
    if (this.state.showWidget) {
      return (
        <Confirm
          isOpen={this.state.isOpen}
          title="Link to Consumer"
          content="Are you sure you want to connect patient to Consumer Account?"
          onConfirm={this.handleConfirm}
          onClose={this.handleDialogClose}
        />
      );
    } else {
      return null;
    }
  };

  render() {
    return (
      <Fragment>
        <Button
          label="Link To Consumer"
          onClick={this.handleClick}
          color="primary"
        />
        {this.getConfirm()}
      </Fragment>
    );
  }
}

export const LinkPatientToConsumerButton = withDataProvider(
  LinkPatientToConsumerButton_
);

class UnlinkPatientFromConsumerButton_ extends Component {
  state = {
    isOpen: false,
    showWidget: false,
  };

  handleClick = () => {
    this.setState({ isOpen: true, showWidget: true });
  };

  handleDialogClose = () => {
    this.setState({ isOpen: false });
  };

  handleConfirm = () => {
    const { record } = this.props;
    this.setState({ isOpen: false, showWidget: false });
    dataProvider(UNLINK_FROM_CONSUMER, "patients", { id: record.id })
      .then(() => {
        this.props.dispatch(
          showNotification("Patient unlinked from Consumer Backed")
        );
        this.props.dispatch(refreshView());
      })
      .catch((err) => {
        const message = R.pathOr(null, ["body", "message"], err);
        const status = R.pathOr(null, ["status"], err);
        if (status === 404) {
          this.props.dispatch(
            showNotification("User not found at Consumer", "warning")
          );
          return;
        }
        if (message) {
          this.props.dispatch(showNotification(message, "warning"));
          return;
        } else {
          this.props.dispatch(showNotification("Error: unknown", "warning"));
        }
      });
  };

  getConfirm = () => {
    if (this.state.showWidget) {
      return (
        <Confirm
          isOpen={this.state.isOpen}
          title="Unlink from Consumer"
          content="Are you sure you want to unlink patient from Consumer Account?"
          onConfirm={this.handleConfirm}
          onClose={this.handleDialogClose}
        />
      );
    } else {
      return null;
    }
  };

  render() {
    return (
      <Fragment>
        <Button
          label="Unlink From Consumer"
          onClick={this.handleClick}
          color="secondary"
        />
        {this.getConfirm()}
      </Fragment>
    );
  }
}

export const UnlinkPatientFromConsumerButton = withDataProvider(
  UnlinkPatientFromConsumerButton_
);
